// `/admin/sellers/$id`, o CONTEÚDO do drawer que a rota-pai (`admin.sellers.tsx`)
// desenha por cima da lista (`spec/24` §1 decisão 5). O cabeçalho (nome, id e `Pill` de
// status) é do `RouteDrawer` da pai, que usa a MESMA query desta rota.
//
// Aqui só ficam os três estados de carga do detalhe; a tela é
// `features/admin-sellers/seller-detail.tsx`.

import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { adminSellerOptions } from '../api/queries/admin-sellers.ts';
import { ErrorState } from '../components/app/error-state.tsx';
import { CardSkeleton } from '../components/app/skeletons.tsx';
import { Empty } from '../components/kit/empty.tsx';
import { isNotFound } from '../features/admin-sellers/errors.ts';
import { SellerDetail } from '../features/admin-sellers/seller-detail.tsx';

function AdminSellerDrawer() {
  const { id } = Route.useParams();
  const detail = useQuery(adminSellerOptions(id));

  if (detail.isPending) {
    return <CardSkeleton lines={6} />;
  }

  if (isNotFound(detail.error)) {
    return (
      <Empty
        title="Seller não encontrado"
        hint="Este id não existe. Confira o link ou volte para a lista."
      />
    );
  }

  if (detail.isError) {
    return (
      <ErrorState
        error={detail.error}
        onRetry={() => {
          void detail.refetch();
        }}
      />
    );
  }

  return <SellerDetail seller={detail.data} />;
}

export const Route = createFileRoute('/admin/sellers/$id')({ component: AdminSellerDrawer });
